<template>
	<div>
		<div v-if="appointment.reasons && appointment.reasons.length > 0" class="font-weight-bold">
			{{ appointment.reasons.join(', ')}}
		</div>
		<div v-if="isTypeEligible" class="mt-1">
			<div v-if="appointment.type === types.videoCall">Video-Telefonat</div>
			<div v-if="appointment.type === types.phoneCall">
				<template v-if="isTypeApplicant">
					Telefonat (Du wirst angerufen unter der von dir angegebenen Mobilnummer:
					<b>{{ appointment.phone.formatted }}</b> - Deine Rufnummer wird kurz vor dem Termin an den
					Gesprächspartner weitergegeben.)
				</template>
				<template v-else>Telefonat</template>
			</div>
			<div v-if="appointment.onlineActivity">
				Onlinetätigkeit
				<span v-if="appointment.onlineActivityExecution">({{ onlineActivityExecution }})</span>
			</div>
		</div>
		<div v-if="appointment.duration" class="font-weight-bold mt-1">Dauer ungefähr {{ appointment.duration }}</div>
		<div v-if="appointment.location" class="font-weight-bold mt-1">{{ appointment.location }}</div>
		<div v-if="appointment.participants && appointment.participants.length > 0" class="mt-1">
			<div>Mit:</div>
			<div v-for="(participant, i) in appointment.participants" :key="'participant-' + i" class="font-weight-bold">
				{{ participant }}
			</div>
		</div>
		<template v-if="isTypeCustomer">
			<div v-if="appointment.phone" class="font-weight-bold mt-1">
				<a :href="'tel:' + appointment.phone.full">{{ appointment.phone.formatted }}</a>
			</div>
			<div v-if="appointment.linkEligible" class="font-weight-bold mt-1">
				<span v-if="sentAccessLink">
					<Icon icon="checkmark" class="mr-1" color="green"/>
					Zugangsdaten gesendet
					<a href="#" @click="sendAccessLink = true" class="ml-1">
						<Icon icon="edit" color="primary"/>
					</a>
				</span>
				<a v-else href="#" class="font-size-smaller" @click.prevent="sendAccessLink = true">
					<Icon icon="key-chain" color="primary" size="1comma5x" class="mr-2"/>
					Zugangsdaten (Link) senden
				</a>
			</div>
		</template>
		<div v-if="isTypeApplicant && appointment.linkEligible && appointment.accessLink" class="mt-2">
			<div>
				<a :href="appointment.accessLink" target="_blank">
					Klicke hier um den Link der Firma zu öffnen
				</a>
			</div>
			<div v-if="appointment.accessLinkUsername">
				Benutzername: {{ appointment.accessLinkUsername }}
			</div>
			<div v-if="appointment.accessLinkPassword">
				Passwort: {{ appointment.accessLinkPassword }}
			</div>
		</div>
		<JonInfo
			v-if="isTypeApplicant && appointment.linkEligible && !appointment.accessLink"
			class="mt-2"
		>
			<template #message>
				<template v-if="appointment.type === types.videoCall">
					Zugangsdaten zum Videoanruf erhältst du nach der Terminvereinbarung von der Firma.
				</template>
				<template v-else>
					Zugangsdaten erhältst du nach der Terminvereinbarung von der Firma.
				</template>
			</template>
		</JonInfo>
		<SendAccessLinkPopUp
			v-if="sendAccessLink"
			:appointment="appointment"
			@sent="onSentAccessLink"
			@hidden="sendAccessLink = false"
		/>
	</div>
</template>

<script>
import * as AppointmentType from "@/helper/communication/conversation/appointment/Type";
import * as AppointmentOnlineActivityExecution
	from "@/helper/communication/conversation/appointment/OnlineActivityExecution";
import Icon from "@/vue/icon/Icon.vue";
import SendAccessLinkPopUp from "@/vue/communication/appointment/SendAccessLinkPopUp.vue";
import {isDefined} from "@/helper/Value";
import JonInfo from "@/vue/common/JonInfo.vue";

const TYPE_APPLICANT = 'applicant';

export default {
	components: {JonInfo, SendAccessLinkPopUp, Icon},

	props: {
		appointment: {
			type: Object,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			types: {
				phoneCall: AppointmentType.PHONE_CALL,
				videoCall: AppointmentType.VIDEO_CALL,
			},
			sentAccessLink: isDefined(this.appointment.accessLink),
			sendAccessLink: false,
		};
	},

	computed: {
		isTypeEligible ()
		{
			return this.appointment.type === AppointmentType.PHONE_CALL
				|| this.appointment.type === AppointmentType.VIDEO_CALL
				|| this.appointment.onlineActivity;
		},
		isTypeApplicant ()
		{
			return this.type === TYPE_APPLICANT;
		},
		isTypeCustomer ()
		{
			return !this.isTypeApplicant;
		},
		onlineActivityExecution ()
		{
			return AppointmentOnlineActivityExecution.getLabel(this.appointment.onlineActivityExecution);
		},
	},

	methods: {
		onSentAccessLink ()
		{
			this.sentAccessLink = true;
			this.sendAccessLink = false;
		}
	}
}
</script>
